import React from 'react'
import { Link } from 'react-router-dom'
import './Footer.scss'

function Footer() {
  return (
    <footer className="app-footer">
      <div className="footer-container">
        <div className="footer-content">
          <p className="footer-copyright">
            © JobsReadyAI. All rights reserved
          </p>
          <nav className="footer-nav">
            <a 
              href="https://jobsreadyai.zohodesk.com/portal/" 
              target="_blank" 
              rel="noreferrer noopener" 
              className="footer-link"
            >
              Help center
            </a>
            <span className="footer-divider">|</span>
            <Link to="/privacy" className="footer-link">
              Privacy policy
            </Link>
            <span className="footer-divider">|</span>
            <Link to="/eula" className="footer-link">
              EULA
            </Link>
          </nav>
        </div>
      </div>
    </footer>
  )
}

export default Footer
